// removed by extract-text-webpack-plugin
module.exports = {"ExtensionInviteModalContent":"ExtensionInviteModalContent---XqnVe","ExtensionInviteModalHeader":"ExtensionInviteModalHeader---oevAX","invite-user-wizard-modal":"invite-user-wizard-modal---PoCrD"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/playbook/components/ExtensionInviteModal/style.styl
// module id = F4+Y
// module chunks = 89